import "./whiteHeader.css"
import logo from "../assets/logo.jpg"
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import m1 from "../../src/assets/photos/ISO/3.jpg"

const projectData = [
    {
        title: "Konut Projeleri",
        subItems: [
            {
                title: "Devam Eden Projeler",
                projects: [{ title: "Mezarlık Kompleksi Yozgat Sorgun", slug: "mezarlik-kompleksi-yozgat-sorgun" }]
            },
            {
                title: "Tamamlanan Projeler",
                projects: [{ title: "Malatya 404 Konut Toki Projesi", slug: "malatya-toki-projesi" }]
            }
        ]
    }
];

const WhiteHeader = ({ scrollTargetRef }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const isProjectPage = location.pathname.startsWith("/projeler/");
    const [isCertOpen, setCertOpen] = useState(false);
    const [isScrolled, setisScrolled] = useState(false);
    const [isMobile, setMobile] = useState(false);
    const [isProjelerOpen, setIsProjelerOpen] = useState(false);
    const [isDrawerOpen, setDrawerOpen] = useState(false);
    const [isMobileProjectsOpen, setMobileProjectsOpen] = useState(false);

    const handleScrollClick = (targetRef) => {
        targetRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    useEffect(() => {
        const handleScroll = () => setisScrolled(window.scrollY > 50);
        const handleClick = () => setIsProjelerOpen(false);

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('click', handleClick);

        if (window.innerWidth <= 768) setMobile(true);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('click', handleClick);
        };
    }, []);

    const toggleProjeler = (e) => {
        e.stopPropagation();
        setIsProjelerOpen(prev => !prev);
    };

    return (
        <>
            <motion.header
                animate={{
                    height: isScrolled ? '70px' : '100px',
                    backgroundColor: isScrolled ? 'rgba(26, 115, 115, 0.8)' : 'rgba(26, 115, 115, 1)',
                }}
                transition={{ duration: 0.3 }}
                className={`fixed-header ${isScrolled ? 'scrolled' : ''}`}
            >
                <div className="header-middle-image" onClick={() => navigate("/")}>
                    <motion.div
                        animate={{
                            scale: isScrolled ? 0 : 1,
                            width: isScrolled ? 0 : "auto",
                            opacity: isScrolled ? 0 : 1,
                            marginRight: isScrolled ? "0px" : "15px"
                        }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ overflow: 'hidden' }}
                    >
                        <img
                            src={logo}
                            alt="Sembol"
                            style={{ width: "auto", height: "50px" }}
                        />
                    </motion.div>
                    <div className={!isScrolled ? "header-title" : "header-title-shrunk"}>
                        <h3 style={!isScrolled ? { margin: 0, fontSize: isMobile ? "1rem" : "1.7rem" } : { margin: 0 }}>
                            Güçlükaya İnşaat
                        </h3>
                        <h3 style={{ margin: 0 }}>San. ve TİC. Ltd. ŞTİ.</h3>
                    </div>
                </div>

                {/* Desktop nav - mobilde gizlenir */}
                {!isMobile && (
                    <div className="header-columns">
                        {isCertOpen && (
                            <div className="lightbox" onClick={() => setCertOpen(false)}>
                                <img
                                    src={m1}
                                    alt="Sertifikamız"
                                    className="lightbox-image"
                                    onClick={(e) => e.stopPropagation()}
                                />
                            </div>
                        )}
                        <div className="buttons" onClick={() => navigate("/")}>Ana Sayfa</div>
                        <div className="buttons" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[0]) }}>Kurumsal</div>

                        <div className="nav-item-wrapper">
                            <div className="nav-group" onClick={toggleProjeler}>
                                <span className="nav-link">PROJELER</span>
                                <span className={`arrow-icon ${isProjelerOpen ? 'open' : ''}`}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4">
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </span>
                            </div>
                            <div
                                className={`dropdown-menu ${isProjelerOpen ? 'open' : ''}`}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {projectData.map((category, idx) => (
                                    <div key={idx} className="dropdown-category">
                                        <span className="category-title">{category.title}</span>
                                        {category.subItems.map((sub, sIdx) => (
                                            <div key={sIdx} className="submenu-item">
                                                <span>{sub.title}</span>
                                                <span className="side-arrow">»</span>
                                                <div className="project-list-side">
                                                    {sub.projects.map((p, pIdx) => (
                                                        <div
                                                            key={pIdx}
                                                            className="project-link"
                                                            onClick={() => navigate(`/projeler/${p.slug}`)}
                                                        >
                                                            {p.title}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="buttons" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[2]) }}>KARİYER</div>
                        <div className="buttons" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[3]) }}>POLİTİKAMIZ</div>
                        <div className="buttons" onClick={() => navigate("/sertifika")}>SERTİFİKALARIMIZ</div>
                        <div className="buttons" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[2]) }}>İLETİŞİM</div>


                    </div>
                )}

                {/* Hamburger - sadece mobilde */}
                {isMobile && (
                    <div className="hamburger" onClick={(e) => { e.stopPropagation(); setDrawerOpen(prev => !prev); }}>
                        <span className={`hamburger-line ${isDrawerOpen ? 'open' : ''}`} />
                        <span className={`hamburger-line ${isDrawerOpen ? 'open' : ''}`} />
                        <span className={`hamburger-line ${isDrawerOpen ? 'open' : ''}`} />
                    </div>
                )}
            </motion.header>

            {/* Drawer - motion.header dışında */}
            {isMobile && (
                <>
                    <div
                        className={`drawer-overlay ${isDrawerOpen ? 'open' : ''}`}
                        onClick={() => setDrawerOpen(false)}
                    />
                    <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
                        <nav className="drawer-nav">
                            <div className="drawer-item" onClick={() => { navigate("/"); setDrawerOpen(false); }}>
                                Ana Sayfa
                            </div>


                            <div className="drawer-item" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[0]); setDrawerOpen(false); }}>
                                Kurumsal
                            </div>


                            <div className="drawer-item drawer-accordion" onClick={() => setMobileProjectsOpen(prev => !prev)}>
                                <span>Projeler</span>
                                <span className={`arrow-icon ${isMobileProjectsOpen ? 'open' : ''}`}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="4">
                                        <path d="M6 9l6 6 6-6" />
                                    </svg>
                                </span>
                            </div>

                            <div className={`drawer-accordion-content ${isMobileProjectsOpen ? 'open' : ''}`}>
                                {projectData.map((category, idx) => (
                                    <div key={idx}>
                                        <span className="drawer-category-title">{category.title}</span>
                                        {category.subItems.map((sub, sIdx) => (
                                            <div key={sIdx}>
                                                <span className="drawer-sub-title">{sub.title}</span>
                                                {sub.projects.map((p, pIdx) => (
                                                    <div
                                                        key={pIdx}
                                                        className="drawer-project-link"
                                                        onClick={() => { navigate(`/projeler/${p.slug}`); setDrawerOpen(false); }}
                                                    >
                                                        {p.title}
                                                    </div>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>


                            <div className="drawer-item" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[2]); setDrawerOpen(false); }}>
                                KARİYER
                            </div>
                            <div className="drawer-item" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[3]); setDrawerOpen(false); }}>
                                POLİTİKAMIZ
                            </div>
                            <div className="drawer-item" onClick={() => { if (!isProjectPage) handleScrollClick(scrollTargetRef[2]); setDrawerOpen(false); }}>
                                İLETİŞİM
                            </div>


                        </nav>
                    </div>
                </>
            )}
        </>
    );
}

export default WhiteHeader;